export const ReportCodesToHelpCodesMap = {
	experience: "home.reports.EXP",
	"eq5d-5l": "home.reports.EQ5D",
	lcss: "home.reports.SAQ",
	"fact-g7": "home.reports.FACTG7",
	"start-mr": "home.reports.start",
	cost: "home.reports.cost",
	clinical: "home.reports.clinical",
};
